import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Login = lazy(() => import('./pages/Login'));
const SelectBranch = lazy(() => import('./pages/SelectBranch'));

const authRoutes: RouteObject[] = [
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'select-branch',
    element: <SelectBranch />,
  },
];

export default authRoutes;
